// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sd-container {
    width: 100%;
    height: 100%;
    position: relative;
}

.sd-content {
    width: 100%;
    height: 100%;
}

/* Placeholder overlay */
.sd-placeholder {
    position: absolute;
    inset: 0;
    background-color: var(--sd-placeholder-bg, #cccccc);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease-out;
}

    .sd-placeholder.sd-visible {
        opacity: 1;
        pointer-events: auto;
    }

.sd-placeholder-content {
    text-align: center;
    padding: 1rem;
    font-size: 1.2rem;
    color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/Controls/css/ScrollDetacher.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,QAAQ;IACR,mDAAmD;IACnD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,iCAAiC;AACrC;;IAEI;QACI,UAAU;QACV,oBAAoB;IACxB;;AAEJ;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".sd-container {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n}\r\n\r\n.sd-content {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n/* Placeholder overlay */\r\n.sd-placeholder {\r\n    position: absolute;\r\n    inset: 0;\r\n    background-color: var(--sd-placeholder-bg, #cccccc);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    transition: opacity 0.2s ease-out;\r\n}\r\n\r\n    .sd-placeholder.sd-visible {\r\n        opacity: 1;\r\n        pointer-events: auto;\r\n    }\r\n\r\n.sd-placeholder-content {\r\n    text-align: center;\r\n    padding: 1rem;\r\n    font-size: 1.2rem;\r\n    color: #333;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
